// ** Auth Endpoints
export default {
  //loginEndpoint: 'http://127.0.0.1/api/login',
  loginEndpoint:  `${process.env.REACT_APP_API_URL}login`,
  registerEndpoint: `${process.env.REACT_APP_API_URL}register/`,
  backEndpoint: process.env.REACT_APP_API_URL,
  refreshEndpoint: `${process.env.REACT_APP_API_URL}auth/refresh`,
  logoutEndpoint: '/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: '',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'access_token',
  storageRefreshTokenKeyName: 'refresh_token'
}